export default {
      id: "sparkle-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#sparkle-usage",
      toString: function () {
        return this.url;
      }
    }